import React, { useEffect, useState } from 'react'
import { getAllData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../_actions/loader.actions';
import { alphaNumericspace, getDateCombination, isImageValidPng, onlyAlphabets } from '../../../commonClass/CommonValidation';
import { ImageDelete, ImageUpload } from '../../../../ImageUpload/ImageCommon';
import CustomTable from '../../../../customControl/CustomTable';
import { Rating } from 'react-simple-star-rating';
import CommonFilter from '../../../../customControl/CommonFilter';

const Testimonial = ({ useredit, useradd }) => {
    const dispatch = useDispatch();
    const userId = GetLocalStorage();
    const [testimonialList, setTestimonialList] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [formError, setFormError] = useState({});
    const [deletedImage, setDeletedImage] = useState([]);

    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState('All');
    const [serchdisable, setSerachDisable] = useState(false);

    const [formValue, setFormValue] = useState({
        UserId: userId?.userMasterID,
        CustomerId: 0,
        CustomerName: "",
        PackageName: "",
        Ratings: 0,
        Review: "",
        CustomerImageName: "",
        CustomerImagePath: "",
        CustomerImageFile: "",
    })

    const getTestimoniallist = async () => {
        const testimoniallists = await getAllData(`/master/v1/gettestimoniallist`);
        if (testimoniallists?.status) {
            setTestimonialList(testimoniallists?.data)
            setFilterData(testimoniallists?.data)
        }
        else {
            setTestimonialList([])
            setFilterData([])
        }
        dispatch(loaderActions.end());
    }

    //#region List data
    useEffect(() => {
        const fetchData = async () => {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                let token = GetLocalStorage();
                if (token && token.userName && token.token) {
                    getTestimoniallist();
                }
            } else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
        fetchData();
    }, []);

    const storeDataInState = (name, value) => {
        setFormError({})
        setFormValue({ ...formValue, [name]: value })
    }

    const handleUploadImageLoad = (e) => {
        setFormError({});
        let error = {}
        if (isImageValidPng(e.target.files[0].name)) {
            const files = e.target.files[0];
            const filename = getDateCombination(files.name);
            setDeletedImage([...deletedImage, formValue.CustomerImagePath]);
            setFormValue({
                ...formValue,
                CustomerImageName: filename,
                CustomerImagePath: 'CMS/testimonial/' + filename,
                CustomerImageFile: files,
            })
            e.target.value = null
        }
        else {
            error.CustomerImagePath = 'Only PNG file type is accepted.';
            setFormError(error);
        }
        e.target.value = null
    }

    const checkValidation = () => {
        let errorMessages = {};
        let isError = true;

        if (formValue.CustomerName?.trim().length <= 0) {
            errorMessages['CustomerName'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }
        if (formValue.PackageName?.trim().length <= 0) {
            errorMessages['PackageName'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }
        if (formValue.Review?.trim().length <= 0) {
            errorMessages['Review'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }
        if (formValue.Ratings <= 0) {
            errorMessages['Ratings'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }

        if (!formValue?.CustomerImagePath) {
            errorMessages['CustomerImagePath'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        } else if (formValue.CustomerImageFile) {
            const files = formValue.CustomerImageFile;
            let fileSize = files.size / 1024;
            fileSize = fileSize / 1024
            if (!isImageValidPng(files.name) && files) {
                errorMessages['CustomerImagePath'] = 'Only PNG file type is accepted.'
                isError = false;
            } else if (fileSize > 5) {
                errorMessages['CustomerImagePath'] = 'Cannot upload file that exceeds 5 MB.'
                isError = false;
            }
        }

        setFormError(errorMessages);
        return isError;
    }

    const onSubmitTestimonial = async () => {
        const isValid = checkValidation();
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            if (isValid) {
                dispatch(loaderActions.start());
                const updateTestimonial = await postUsersData('/master/v1/insertorupdatetestimonial', formValue);

                if (updateTestimonial.status) {
                    formValue?.CustomerImageFile && await ImageUpload('CMS/testimonial/', formValue?.CustomerImageName, formValue?.CustomerImageFile);
                    deletedImage.length > 0 && deletedImage.forEach(async (deletedImagePath) => await ImageDelete(deletedImagePath));
                    getTestimoniallist();
                    onClearButton();
                    dispatch({ type: 'ALERTING', message: updateTestimonial.message })
                    dispatch(loaderActions.end());
                }
                else {
                    dispatch(loaderActions.end());
                    dispatch({ type: 'ALERTING', message: updateTestimonial.message })
                    return;
                }
            }
        } else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            dispatch(loaderActions.end());
        }
    }

    const columns = [
        {
            name: 'Sr. No.',
            sortable: true,
            float: "left",
            minWidth: "20px",
            maxWidth: "20px",
            selector: (data, index) => index + 1,
        },
        {
            name: 'Customer Name',
            key: "CustomerName",
            sortable: true,
            float: "left",
            selector: (data) => data.CustomerName,
        },
        {
            name: 'Package Name',
            key: "PackageName",
            sortable: true,
            float: "left",
            selector: (data) => data.PackageName,
        },
        {
            name: 'Ratings',
            key: "Ratings",
            sortable: true,
            float: "left",
            selector: (data) => data.Ratings,
        },
        {
            name: 'Edit',
            selector: data => <button type='button' className='border-0 p-0 bg-body set_disableclr'
                onClick={() => onEditorView(data, 'edit')}
                disabled={!useredit}
            ><i className="fa fa-edit eye-icon"></i></button>
        },
        {
            name: 'View',
            selector: data => <button type='button' className='border-0 p-0 bg-body set_disableclr' onClick={() => onEditorView(data, 'view')} ><i className="fa fa-eye" ></i></button>
        }
    ]

    const onEditorView = async (data, type) => {
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            setSerachDisable(true)
            const review = await getAllData(`/master/v1/gettestimonialbycustomerid?customerId=${data?.CustomerId}`);
            setFormError({});
            if (review?.status) {
                setFormValue(
                    {
                        UserId: userId?.userMasterID,
                        CustomerId: review?.data?.CustomerId,
                        CustomerName: review?.data?.CustomerName,
                        PackageName: review?.data?.PackageName,
                        Ratings: review?.data?.Ratings,
                        Review: review?.data?.Review,
                        CustomerImageName: review?.data?.CustomerImageName,
                        CustomerImagePath: review?.data?.CustomerImagePath,
                        CustomerImageFile: "",
                        type: type
                    }
                )
            }
        } else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            dispatch(loaderActions.end());
        }
        dispatch(loaderActions.end());
    }

    const onClearButton = () => {
        setSerachDisable(false)
        setFormError({});
        setFormValue(
            {
                UserId: userId?.userMasterID,
                CustomerId: 0,
                CustomerName: "",
                PackageName: "",
                Ratings: "",
                Review: "",
                CustomerImageName: "",
                CustomerImagePath: "",
                CustomerImageFile: "",
            }
        )
    }

    return (
        <div className='px-xl-5 py-4 p-xl-4'>
            <div className=" heading_color mb-3">
                <h4>Testimonial</h4>
            </div>

            <form action=" " className=' mb-5' >
                <div className='row'>
                    <div className='row col-6 my-1'>
                        <div className="col-xl-3 col-12 mb-1">
                            <label className="col-form-label required" htmlFor='customer-name'>Customer Name</label>
                        </div>
                        <div className="col-xl-9 mb-1 col-12">
                            <div class="input-group">
                                <input
                                    type="text" id="customer-name"
                                    class="form-control btn_add"
                                    placeholder="Customer Name"
                                    maxLength={150}
                                    name='CustomerName'
                                    value={formValue?.CustomerName || ''}
                                    onChange={(e) => storeDataInState(e.target.name, onlyAlphabets(e.target.value))}
                                    disabled={formValue?.type === 'view' ? true : false}
                                />
                            </div>
                            {formError.CustomerName && <div className='text-danger text-start'>{formError.CustomerName}</div>}
                        </div>
                    </div>
                    <div className='row col-6 my-1'>
                        <div className="col-xl-3 col-12 mb-1">
                            <label className="col-form-label required" htmlFor='package-name'>Package Name</label>
                        </div>
                        <div className="col-xl-9 mb-1 col-12">
                            <div class="input-group">
                                <input
                                    type="text" id="package-name"
                                    class="form-control btn_add"
                                    placeholder="Package Name"
                                    maxLength={150}
                                    name='PackageName'
                                    value={formValue.PackageName || ''}
                                    onChange={(e) => storeDataInState(e.target.name, alphaNumericspace(e.target.value))}
                                    disabled={formValue?.type === 'view' ? true : false}
                                />
                            </div>
                            {formError.PackageName && <div className='text-danger text-start'>{formError.PackageName}</div>}
                        </div>
                    </div>
                    <div className='row col-6 my-1'>
                        <div className="col-xl-3 col-12 mb-1 align-content-center">
                            <label className="col-form-label required" htmlFor='Ratings'>Ratings</label>
                        </div>
                        <div className="col-xl-9 mb-1 col-12 align-content-center">
                            <div class="input-group">
                                <Rating
                                    size={50}
                                    allowFraction
                                    readonly={formValue?.type === 'view' ? true : false}
                                    initialValue={formValue.Ratings}
                                    id="Ratings"
                                    onClick={(rat) => storeDataInState('Ratings', rat)}
                                />
                            </div>
                            {formError.Ratings && <div className='text-danger text-start'>{formError.Ratings}</div>}
                        </div>
                    </div>
                    <div className='row col-6 my-1'>
                        <div className="col-xl-3 col-12 mb-1 align-content-center">
                            <label className="col-form-label required" htmlFor='review'>Review</label>
                        </div>
                        <div className="col-xl-9 mb-1 col-12">
                            <div class="input-group">
                                <textarea
                                    id="review"
                                    class="form-control btn_add"
                                    placeholder="Review"
                                    maxLength={500}
                                    name='Review'
                                    rows={4}
                                    value={formValue.Review || ''}
                                    onChange={(e) => storeDataInState(e.target.name, alphaNumericspace(e.target.value))}
                                    disabled={formValue?.type === 'view' ? true : false}
                                />
                            </div>
                            {formError.Review && <div className='text-danger text-start'>{formError.Review}</div>}
                        </div>
                    </div>

                    <div className='row col-6 my-1'>
                        <div className="col-xl-3 col-12 mb-1">
                            <label className="col-form-label required" htmlFor='CustomerImage-id'>Customer Image</label>
                        </div>
                        <div className="col-xl-9 mb-1 col-12">
                            <div class="input-group">
                                <input
                                    type="file"
                                    name='CustomerImage'
                                    id="CustomerImage-id"
                                    className="form-control btn_add"
                                    accept=".png"
                                    onChange={(e) => handleUploadImageLoad(e)}
                                    disabled={formValue?.type === 'view' ? true : false}
                                />
                                <label className="input-group-text" htmlFor="CustomerImage-id">Browse</label>
                            </div>
                            {formValue.CustomerImageName && (
                                <div className='d-flex justify-content-center align-item-center w-100 '>
                                    <div className='text-start w-100 text-break'>{formValue.CustomerImageName}</div>
                                </div>
                            )}
                            {formError.CustomerImagePath && <div className='text-danger text-start'>{formError.CustomerImagePath}</div>}
                        </div>
                    </div>
                </div>
            </form>

            <CommonFilter
                columns={columns}
                filterList={filterData}
                searchDisabled={serchdisable}
                getdata={getTestimoniallist}
                setlistdata={setTestimonialList}
                searchvalue={searchvalue}
                setSearchValue={setSearchValue}
                searchby={searchby}
                setSerachBy={setSerachBy}
            />

            <CustomTable
                columns={columns}
                data={testimonialList}
                PdfExport={false}
                ExportToExcel={false}
                disabled={false}
            />

            <div class="d-flex justify-content-center">
                {
                    formValue?.type === 'edit'
                        ? (<button class="btn btn-primary mx-1" id="btnAdd" type='button'
                            onClick={() => onSubmitTestimonial()}
                            disabled={!useredit}
                        >Update</button>
                        )
                        : (<button class="btn btn-primary mx-1" id="btnAdd" type='button'
                            onClick={() => onSubmitTestimonial()}
                            disabled={!useradd}
                        >Add</button>)
                }

                <button type="button" class="btn btn-primary mx-1" id="btnClear"
                    onClick={() => onClearButton({})}
                >Clear</button>
            </div>
        </div>
    )
}

export default Testimonial